module.exports = __webpack_public_path__ + "fonts/SuisseIntl-RegularItalic.f596573.woff2";